<div id="int-requests-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.requests.title' | translate">
    @if (api.hasPermission('create_requests')) {
      <reactive-button
        actions
        [label]="'internal.requests.newRequest' | translate"
        icon="add"
        variant="outlined"
        (onClick)="editRequest()"
      ></reactive-button>
    }
  </app-internal-toolbar>

  <div class="w-full h-fit overflow-auto">
    <p-table
      #requestsTable
      [value]="requests()"
      dataKey="_id"
      [paginator]="true"
      [rows]="10"
      [tableStyle]="{ 'min-width': '30rem' }"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['name', 'location', 'contact', 'contactMail']"
    >
      <ng-template #caption>
        <div class="flex items-end">
          <p-select class="ml-auto" [options]="allSchoolyears()" [(ngModel)]="selectedSchoolyear" [loading]="loading()">
            <ng-template #selectedItem let-year>
              <div>{{ year }} - {{ year + 1 }}</div>
            </ng-template>
            <ng-template let-year #item>
              <div>{{ year }} - {{ year + 1 }}</div>
            </ng-template>
          </p-select>

          <p-iconfield iconPosition="left" class="ml-2">
            <p-inputicon>
              <mat-icon [size]="20">search</mat-icon>
            </p-inputicon>
            <input
              #searchInput
              pInputText
              type="text"
              (input)="requestsTable.filterGlobal($event.target.value, 'contains')"
              [placeholder]="'general.searchPlaceholder' | translate"
            />
            @if (searchInput.value) {
              <p-inputicon
                class="cursor-pointer m-auto"
                (click)="searchInput.value = ''; requestsTable.filterGlobal('', 'contains');"
              >
                <mat-icon>close</mat-icon>
              </p-inputicon>
            } @else {
              <div [style.width]="'28px'"></div>
            }
          </p-iconfield>
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th style="width: 22.5%">{{ 'internal.requests.name' | translate }}</th>
          <th style="width: 22.5%">{{ 'internal.requests.location' | translate }}</th>
          <th style="width: 22.5%">{{ 'internal.requests.date' | translate }}</th>
          <th style="width: 22.5%">{{ 'internal.requests.contact' | translate }}</th>
          <th style="width: 10%">{{ 'general.edit' | translate }}</th>
        </tr>
        <tr class="desktop">
          <th>
            <p-columnFilter
              type="text"
              field="name"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="location"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th></th>
          <th>
            <p-columnFilter
              type="text"
              field="contact"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-request>
        <tr>
          @if (loading()) {
            <td><p-skeleton height="3rem" /></td>
            <td><p-skeleton height="3rem" /></td>
            <td><p-skeleton height="3rem" /></td>
            <td><p-skeleton height="3rem" /></td>
            <td><p-skeleton height="3rem" /></td>
          } @else {
            <td class="font-bold">{{ request.name }}</td>
            <td>{{ request.location }}</td>
            <td>
              <div class="flex flex-col">
                {{ request.startdate | date: 'short' }}
                <span class="text-neutral-500">{{ request.enddate | date: 'short' }}</span>
              </div>
            </td>
            <td>
              <div class="flex flex-col">
                {{ request.contact }}
                <span class="text-neutral-500">{{ request.contactMail }}</span>
              </div>
            </td>
            <td>
              <div class="flex flex-row">
                <p-button [rounded]="true" [outlined]="true" (onClick)="editRequest(request)">
                  <mat-icon>edit</mat-icon>
                </p-button>
              </div>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- <app-internal-requests-edit-dialog #editDialog></app-internal-requests-edit-dialog> -->
</div>
